<template>
    <div class="ios-tab-pane">

        <div class="pdf-container">
            <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="false"
                :paginate-elements-by-height="0" :filename="'ENTRADA_MERCANCIA_' + PurchaseDeliveryNote?.DocNum"
                :pdf-quality="2" :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait"
                pdf-content-width="210mm" :htmlToPdfOptions="htmlToPdfOptions" @beforeDownload="onPdfGenerated($event)"
                ref="html2Pdf">
                <section slot="pdf-content" class="sap-report">
                    <div v-for="(page, pageIndex) in itemsPages" :key="pageIndex" class="pdf-page-container">
                        <!-- Header (repeated on every page) -->
                        <div class="sap-header"
                            style="display: flex; align-items: stretch; border: 0px solid white; margin-bottom: 8px;">
                            <div
                                style="flex: 1; display: flex; justify-content: start; align-items: start;flex-direction: column;">
                                <img src="/static/logo_sp.png" alt="Logo" style="width: 140px; height: auto;">
                                <h1 class="brand-title"
                                    style="font-size: 14px; font-weight: bold; color: #000; margin: 0; text-transform: uppercase;">
                                    SUNSHINE EXPORT S.A.C.</h1>
                                <p class="company-tel" style="font-size: 10px; color: #000; margin: 4px 0 0 0;">
                                    Telf.: 073-368262 / 073-368031</p>
                            </div>
                            <div class="document-title"
                                style="flex: 1.5; text-align: right; display: flex; flex-direction: column; justify-content: end;">
                                <h2
                                    style="font-size: 14px; font-weight: bold; margin: 0; color: #000; text-transform: uppercase;text-align:right;">
                                    INGRESO ALMACÉN</h2>
                                <h3
                                    style="font-size: 12px; font-weight: bold; margin: 5px 0 0 0; color: #000;text-align:right;">
                                    N°: {{ PurchaseDeliveryNote?.DocNum }}
                                </h3>
                            </div>
                        </div>

                        <!-- Metadata (only on the first page) -->
                        <div v-if="pageIndex === 0" class="sap-metadata" style="margin-bottom: 8px;">
                            <table style="width: 100%; border-collapse: collapse; border: none;">
                                <tbody>
                                    <tr>
                                        <td
                                            style="width: 10%; vertical-align: top; border: none; padding: 3px 4px; font-weight: bold;">
                                            SR. (ES):
                                        </td>
                                        <td style="width: 50%; vertical-align: top; border: none; padding: 3px 4px;">
                                            {{ PurchaseDeliveryNote?.CardName }}
                                        </td>
                                        <td
                                            style="width: 15%; vertical-align: top; border: none; padding: 3px 4px; padding-left: 15px; font-weight: bold;">
                                            N° ORDEN SAP:
                                        </td>
                                        <td style="width: 22%; vertical-align: top; border: none; padding: 3px 4px;">
                                            N° {{ orderLocal.DocNumSap || '' }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="vertical-align: top; border: none; padding: 3px 4px; font-weight: bold;">
                                            DNI/RUC:
                                        </td>
                                        <td style="vertical-align: top; border: none; padding: 3px 4px;">
                                            {{ PurchaseDeliveryNote?.FederalTaxID }}
                                        </td>
                                        <td
                                            style="vertical-align: top; border: none; padding: 3px 4px; padding-left: 15px; font-weight: bold;">
                                            F. REGISTRO:
                                        </td>
                                        <td style="vertical-align: top; border: none; padding: 3px 4px;">
                                            {{ $fun.formatDateView(PurchaseDeliveryNote?.DocDate) }}
                                            {{ PurchaseDeliveryNote?.DocTime }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="vertical-align: top; border: none; padding: 3px 4px; font-weight: bold;">
                                            DIRECCIÓN:
                                        </td>
                                        <td style="vertical-align: top; border: none; padding: 3px 4px;">
                                            {{ PurchaseDeliveryNote?.Address || '' }}
                                        </td>
                                        <td
                                            style="vertical-align: top; border: none; padding: 3px 4px; padding-left: 15px; font-weight: bold;">
                                            MONEDA:
                                        </td>
                                        <td style="vertical-align: top; border: none; padding: 3px 4px;">
                                            {{ orderLocal?.TypeCurrencyHelper2 }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="vertical-align: top; border: none; padding: 3px 4px; font-weight: bold;">
                                            RESPONSABLE INGRESO:
                                        </td>
                                        <td style="vertical-align: top; border: none; padding: 3px 4px;">
                                            {{ $fun.getUserInfo()?.NtpFullName }}
                                        </td>
                                        <td
                                            style="vertical-align: top; border: none; padding: 3px 4px; padding-left: 15px; font-weight: bold;">
                                            DOC. ENTRADA:
                                        </td>
                                        <td style="vertical-align: top; border: none; padding: 3px 4px;">
                                            {{ tipoDocumentoLabel }} {{ PurchaseDeliveryNote?.U_SYP_MDSD }}
                                            -{{ PurchaseDeliveryNote?.U_SYP_MDCD }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else style="height: 8px;"></div>

                        <!-- Items Table -->
                        <table class="sap-items-table">
                            <thead>
                                <tr>
                                    <th style="width: 4%">#</th>
                                    <th style="width: 9%">Código Item</th>
                                    <th style="width: 35%">Descripción</th>
                                    <th style="width: 8%">Cantidad</th>
                                    <th style="width: 6%">UM</th>
                                    <th style="width: 6%">Almacén</th>
                                    <th style="width: 8%">Precio ME</th>
                                    <th style="width: 8%">Total ME</th>
                                    <th style="width: 8%">Precio MN</th>
                                    <th style="width: 8%">Total MN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in page.items" :key="index">
                                    <td class="text-center">{{ page.startIndex + index + 1 }}</td>
                                    <td>{{ item.codigo }}</td>
                                    <td class="desc-cell">{{ item.descripcion }}</td>
                                    <td class="text-right">{{ item.cantidad.toFixed(2) }}</td>
                                    <td class="text-center">{{ item.um }}</td>
                                    <td class="text-center">{{ item.almacen }}</td>
                                    <td class="text-right">{{ formatPrice(item.precioME, 4) }}</td>
                                    <td class="text-right">{{ formatPrice(item.totalME, 2) }}</td>
                                    <td class="text-right">{{ formatPrice(item.precioMN, 4) }}</td>
                                    <td class="text-right">{{ formatPrice(item.totalMN, 2) }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- Totals (only on the last page) -->
                        <div v-if="pageIndex === itemsPages.length - 1" class="sap-totals-container">
                            <table class="sap-totals-table">
                                <tr>
                                    <td class="totals-label">Sub Total:</td>
                                    <td class="text-right" style="width: 100px;">
                                        {{
                                            formatPrice(PurchaseDeliveryNote?.DocTotalFc - PurchaseDeliveryNote?.VatSumFc,
                                                2)
                                        }}
                                    </td>
                                    <td class="text-right" style="width: 100px;">
                                        {{
                                            formatPrice(PurchaseDeliveryNote?.DocTotal - PurchaseDeliveryNote?.VatSum, 2)
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="totals-label">IGV:</td>
                                    <td class="text-right">{{ formatPrice(PurchaseDeliveryNote?.VatSumFc, 2) }}</td>
                                    <td class="text-right">{{ formatPrice(PurchaseDeliveryNote?.VatSum, 2) }}</td>
                                </tr>
                                <tr class="border-double-top">
                                    <td class="totals-label font-bold">Total:</td>
                                    <td class="text-right font-bold">{{ formatPrice(PurchaseDeliveryNote?.DocTotalFc, 2)
                                        }}
                                    </td>
                                    <td class="text-right font-bold">{{ formatPrice(PurchaseDeliveryNote?.DocTotal, 2)
                                        }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </section>
            </vue-html2pdf>
        </div>


        <v-row class="grc-body">
            <v-col cols="9" class="grc-col-table">

                <!-- ── GRC Header (solo ancho de la tabla) ── -->
                <div class="grc-header" v-if="getAvailableArticlesToDelivery.length > 0">
                    <div class="grc-header-left">
                        <v-icon class="grc-header-icon" color="white" size="28">mdi-truck-fast</v-icon>
                        <span class="grc-header-title">Entradas de Mercancía</span>
                    </div>
                    <div class="grc-header-right">
                        <span class="grc-selected-label">
                            {{ grcSelectedItems.length }} ítem(s) seleccionado(s)
                        </span>
                    </div>
                </div>

                <v-data-table dense :headers="grcHeaders" v-if="getAvailableArticlesToDelivery.length > 0"
                    :items="getAvailableArticlesToDelivery" item-key="LineNumSap" v-model="grcSelectedItems" show-select
                    hide-default-footer :items-per-page="-1" class="grc-table mt-2" @item-selected="onGrcItemSelected"
                    @toggle-select-all="onGrcSelectAll"
                    :class="getAvailableArticlesToDelivery.length > 0 ? 'mb-5' : ''">

                    <template v-slot:item.OddDescription="{ item }">
                        <div class="product-cell">
                            <div class="product-desc" :title="item.OddDescription">
                                {{ item.OddDescription }}
                            </div>
                            <span class="product-code">{{ item.ArtCode }}</span>
                        </div>
                    </template>

                    <template v-slot:item.GrcQuantity="{ item }">
                        <v-text-field v-model.number="item.GrcQuantity" type="number" dense outlined hide-details
                            :min="0" :max="item.OddQuantity" :disabled="!grcIsSelected(item)"
                            :error="item.GrcQuantity > item.OddQuantity" style="width:90px;"
                            class="grc-qty-input rounded-lg" @input="onGrcQtyInput(item)" @blur="onGrcQtyBlur(item)" />
                    </template>

                    <template v-slot:item.GrcRemaining="{ item }">
                        <v-chip small label outlined :color="(item.OpenQtySap - item.GrcQuantity) < 0 ? 'red' : 'grey'"
                            :text-color="(item.OpenQtySap - item.GrcQuantity) < 0 ? 'red' : 'grey'"
                            class="grc-qty-chip font-weight-bold pa-2 rounded-lg text-center">
                            {{ (item.OpenQtySap - item.GrcQuantity).toFixed(2) }}
                            {{ item.UnitMeasurement }}
                        </v-chip>
                    </template>

                    <template v-slot:item.OddQuantity="{ item }">
                        <v-chip small label outlined color="grey" class="grc-qty-chip pa-3 px-5 rounded-lg">
                            {{ item.OddQuantity }} {{ item.UnitMeasurement }}
                        </v-chip>
                    </template>

                    <template v-slot:item.LineStatusSap="{ item }">
                        <v-chip x-small outlined bordered :color="item.LineStatusSap == 'C' ? 'red' : 'green'"
                            class="rounded-lg pa-2 px-1">
                            {{ item.LineStatusSap == 'C' ? 'CERRADO' : 'ABIERTO' }}
                        </v-chip>
                    </template>
                </v-data-table>


                <!-- RESUMEN ENTRADAS MERCANCIA -->
                <div v-if="getLinesDeliveryNotes.length > 0">
                    <div class="grc-header">
                        <div class="grc-header-left">
                            <v-icon class="grc-header-icon" color="white" size="28">mdi-package-variant-closed</v-icon>
                            <span class="grc-header-title">Resumen de Entradas de Mercancía
                            </span>
                        </div>
                        <div class="grc-header-right">
                            <span class="grc-selected-label">
                                {{ getLinesDeliveryNotes.length }} item(s) recepcionado(s)
                            </span>
                        </div>
                    </div>

                    <v-data-table v-if="groupedPurchaseDeliveryNotes.length > 0"
                        :headers="getGroupedHeadersSummaryDeliveryNotes" :items="groupedPurchaseDeliveryNotes"
                        item-key="uniqueId" dense :items-per-page="10" :footer-props="{
                            'items-per-page-options': [5, 10, 15, -1],
                            'items-per-page-text': 'Filas por página'
                        }" class="grc-table mt-2">

                        <template v-slot:item.DocNum="{ item }">
                            <div class="d-flex flex-column align-center justify-center pa-1">
                                <span>{{ item.DocNum }}</span>
                                <v-chip x-small class="pa-1 px-2 font-weight-bold rounded-md">
                                    {{ item.U_SYP_MDSD }}-{{ item.U_SYP_MDCD }}
                                </v-chip>
                            </div>
                        </template>

                        <template v-slot:item.DocDate="{ item }">
                            {{ $fun.formatDateView(item.DocDate) }}
                        </template>

                        <template v-slot:item.total="{ item }">
                            <div class="qty-container text-center" v-if="item.items && item.items.length > 0">
                                {{ item.Currency || orderLocal.TypeCurrencyName }} {{item.items.reduce((acc, curr) =>
                                    acc + (parseFloat(curr.PriceAfVAT) || 0), 0).toFixed(2)}}
                            </div>
                        </template>

                        <template v-slot:item.facturas="{ item }">
                            <div class="text-center d-flex align-center justify-center" style="gap: 4px;"
                                v-if="item.items && item.items.length > 0">
                                <!-- PDF -->
                                <v-tooltip bottom v-if="item.items[0].U_SYP_ANEXO3">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small color="error" v-bind="attrs" v-on="on"
                                            @click.prevent="downloadFileSummary(item.items[0].U_SYP_ANEXO3)">
                                            <v-icon size="20">mdi-file-pdf-box</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Entrada PDF</span>
                                </v-tooltip>

                                <!-- XML -->
                                <v-tooltip bottom v-if="item.items[0].U_SYP_ANEXO4">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small color="success" v-bind="attrs" v-on="on"
                                            @click.prevent="downloadFileSummary(item.items[0].U_SYP_ANEXO4)">
                                            <v-icon size="20">mdi-xml</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Entrada XML</span>
                                </v-tooltip>

                                <span class="grey--text text-caption"
                                    v-if="!item.items[0].U_SYP_ANEXO3 && !item.items[0].U_SYP_ANEXO4">-</span>
                            </div>
                            <div class="text-center grey--text text-caption" v-else>-</div>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <div class="text-center">
                                <v-btn small depressed color="primary" class="rounded-lg"
                                    @click="openDeliveryNoteDetails(item)">
                                    <v-icon small left>mdi-eye</v-icon>
                                    Ver
                                </v-btn>
                            </div>
                        </template>

                    </v-data-table>
                </div>
            </v-col>

            <!-- Form registrar entrada de mercancia Articulos-->
            <!-- Banner: Orden cancelada en SAP -->
            <v-col cols="3" v-if="orderLocal.CANCELED == 'Y'">
                <div class="sap-canceled-banner">
                    <div class="sap-canceled-icon-wrap">
                        <v-icon size="48" color="#dc2626">mdi-cancel</v-icon>
                    </div>
                    <div class="sap-canceled-title">Orden Cancelada en SAP</div>
                    <div class="sap-canceled-subtitle">
                        Esta orden de compra ha sido <strong>CANCELADA</strong> en SAP.
                        No es posible registrar entradas de mercancía.
                    </div>
                </div>
            </v-col>

            <v-col v-else-if="getAvailableArticlesToDelivery.length > 0" cols="3">
                <div class="grc-col-form">
                    <div class="grc-form-title">
                        <v-icon small color="#04abc5" class="mr-1">mdi-form-select</v-icon>
                        Datos del Comprobante
                    </div>

                    <!-- XML & PDF Upload Zone -->
                    <div class="doc-upload-stack mb-3">

                        <!-- XML Card -->
                        <input type="file" ref="fileInputXML_grc" id="xml-upload-input-grc" accept=".xml" hidden
                            @change="handleFileEvent($event)">
                        <label for="xml-upload-input-grc" class="doc-upload-card xml-card"
                            :class="{ 'loaded': xmlFileGrc }">
                            <div class="doc-card-stripe xml-stripe"></div>
                            <div class="doc-card-icon">
                                <v-icon size="30">
                                    {{ xmlFileGrc ? 'mdi-file-xml-box' : 'mdi-code-brackets' }}
                                </v-icon>
                            </div>
                            <div class="doc-card-body">
                                <span class="doc-card-label">Comprobante XML</span>
                                <span class="doc-card-name">
                                    {{ xmlFileGrc ?
                                        xmlFileGrc.name : 'Click para seleccionar archivo.xml'
                                    }}
                                </span>
                            </div>
                            <div class="doc-card-right">
                                <span class="doc-card-badge xml-badge" v-if="!xmlFileGrc">XML</span>
                                <div class="doc-card-success" v-else>
                                    <v-icon size="20" color="#22c55e">mdi-check-circle</v-icon>
                                    <v-btn icon x-small class="doc-delete-btn" @click.stop.prevent="clearXMLFile()">
                                        <v-icon size="16">mdi-close</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </label>

                        <!-- PDF Card (visible only after XML is loaded) -->
                        <transition name="slide-down">
                            <div v-if="xmlFileGrc">
                                <input type="file" ref="fileInputPDF_grc" id="pdf-upload-input-grc" accept=".pdf" hidden
                                    @change="handlePDFFileEvent($event)">
                                <label for="pdf-upload-input-grc" class="doc-upload-card pdf-card"
                                    :class="{ 'loaded': pdfFileGrc }">
                                    <div class="doc-card-stripe pdf-stripe"></div>
                                    <div class="doc-card-icon">
                                        <v-icon size="30">{{ pdfFileGrc ? 'mdi-file-pdf-box' :
                                            'mdi-file-document-outline' }}</v-icon>
                                    </div>
                                    <div class="doc-card-body">
                                        <span class="doc-card-label">Documento PDF</span>
                                        <span class="doc-card-name">
                                            {{ pdfFileGrc ?
                                                pdfFileGrc.name : 'Click para seleccionar archivo.pdf'
                                            }}
                                        </span>
                                    </div>
                                    <div class="doc-card-right">
                                        <span class="doc-card-badge pdf-badge" v-if="!pdfFileGrc">PDF</span>
                                        <div class="doc-card-success" v-else>
                                            <v-icon size="20" color="#ef4444">mdi-check-circle</v-icon>
                                            <v-btn icon x-small class="doc-delete-btn"
                                                @click.stop.prevent="clearPDFFile()">
                                                <v-icon size="16">mdi-close</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </transition>

                    </div>

                    <!-- Motivo -->
                    <div class="grc-field-wrap">
                        <s-select label="Motivo de Traslado" v-model="grcForm.GrcReasonPurchase"
                            :items="transferReasons" outlined dense hide-details clearable></s-select>
                    </div>

                    <!-- Tipo Comprobante -->
                    <div class="grc-field-wrap">
                        <s-select label="TIPO DE COMPROBANTE" v-model="grcForm.U_SYP_MDTD" :items="paymentTypes"
                            outlined dense hide-details clearable></s-select>
                    </div>

                    <!-- Serie + Correlativo en la misma línea -->
                    <div class="grc-field-wrap grc-row-inline">
                        <div class="grc-field-half">
                            <label class="grc-input-label">SERIE</label>
                            <v-text-field v-model="grcForm.GrcSerie" outlined dense hide-details maxlength="4"
                                placeholder="A001" class="grc-field" />
                        </div>
                        <div class="grc-field-half">
                            <label class="grc-input-label">CORRELATIVO</label>
                            <v-text-field v-model="grcForm.GrcCorrelative" outlined dense hide-details maxlength="8"
                                placeholder="00000001" class="grc-field" />
                        </div>
                    </div>

                    <!-- Botón -->
                    <v-btn block color="dark" dark :disabled="grcSelectedItems.length === 0"
                        class="grc-save-btn rounded-lg" elevation="0" @click="submitEntradaMercancia()">
                        <v-icon left small>mdi-check-circle-outline</v-icon>
                        REGISTRAR
                    </v-btn>
                </div>
            </v-col>
        </v-row>

        <AlertSunshine :dialog="processing" />

        <!-- Modal: Detalle de Entrada de Mercancía -->
        <v-dialog v-model="dialogDeliveryNoteDetails" width="1000" v-if="dialogDeliveryNoteDetails" scrollable>
            <v-card class="rounded-xl overflow-hidden">
                <!-- Header -->
                <div class="d-flex align-center justify-space-between px-4 py-2"
                    style="background: linear-gradient(135deg, #04abc5 0%, #04abc5 100%); color: white; min-height: 52px;">
                    <div class="d-flex align-center">
                        <v-icon color="white" size="20" class="mr-2">mdi-package-variant-closed</v-icon>
                        <div>
                            <div class="font-weight-bold" style="font-size: 14px;">
                                Detalle de Entrada de Mercancía
                            </div>
                            <div style="font-size: 11px; opacity: 0.9;" v-if="selectedDeliveryNoteForDetails">
                                Documento N° {{ selectedDeliveryNoteForDetails.DocNum }} ({{
                                    selectedDeliveryNoteForDetails.U_SYP_MDSD
                                }}-{{ selectedDeliveryNoteForDetails.U_SYP_MDCD }})
                            </div>
                        </div>
                    </div>
                    <v-btn icon dark small @click="dialogDeliveryNoteDetails = false">
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>

                <!-- Body / Table of items -->
                <v-card-text class="px-4 py-3" style="max-height: 60vh; overflow-y: auto;">
                    <v-data-table v-if="selectedDeliveryNoteForDetails" :headers="getDetailHeaders"
                        :items="selectedDeliveryNoteForDetails.items" hide-default-footer :items-per-page="-1"
                        class="grc-table" dense>

                        <template v-slot:item.Description="{ item: subItem }">
                            <div class="product-cell">
                                <div class="product-desc" :title="subItem.Description">
                                    {{ subItem.Description }}
                                </div>
                                <div style="display: flex; gap: 5px; align-items: center;">
                                    <span class="product-code" v-if="subItem.ItemCode">{{ subItem.ItemCode }}</span>
                                    <v-chip x-small color="primary" class="pa-2 px-1 text-center"
                                        v-if="subItem.WhsCode">
                                        ALMACÉN: {{ subItem.WhsCode }}
                                    </v-chip>
                                </div>
                            </div>
                        </template>

                        <template v-slot:item.Quantity="{ item: subItem }">
                            <div class="qty-container text-center">
                                {{ subItem.Quantity }} {{ subItem.UnitMsr }}
                            </div>
                        </template>

                        <template v-slot:item.BaseQty="{ item: subItem }">
                            <div class="qty-container text-center">
                                <span class="qty-value">{{ subItem.BaseQty }} {{ subItem.UnitMsr }}</span>
                            </div>
                        </template>

                        <template v-slot:item.Price="{ item: subItem }">
                            <div class="qty-container text-center">
                                {{ subItem.Currency || orderLocal.TypeCurrencyName }} {{ subItem.Price }}
                            </div>
                        </template>

                        <template v-slot:item.PriceAfVAT="{ item: subItem }">
                            <div class="qty-container text-center">
                                {{ subItem.Currency || orderLocal.TypeCurrencyName }} {{ subItem.PriceAfVAT }}
                            </div>
                        </template>

                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _sGeneral from "@/services/HelperService.js";
import _sOrderPurchase from "@/services/Logistics/OrderPurchaseService";
import _sSaleOrder from "@/services/ExternalTrade/SaleOrderService.js";
import _GenUploadFiles from "@/services/General/GenUploadFiles";
import _sOtherSupportService from "@/services/Security/OtherSupportService";
import TrsBudgeService from '@/services/Treasury/TrsBudgeService';
import TrsBudgetDetailService from '@/services/Treasury/TrsBudgetDetailService';
import _sGenParam from "@/services/General/ParameterService";
import _sGenEmail from "@/services/General/GenEmailService";
import VueHtml2pdf from 'vue-html2pdf';

export default {
    name: "PurchaseDeliveryNote",
    components: {
        VueHtml2pdf
    },
    props: {
        orderLocal: { type: Object, default: {} },
    },
    data() {
        return {
            enviando: false,
            PurchaseDeliveryNote: null,

            ValidateBudget: 0,
            grcHeaders: [
                { text: 'LINEA', value: 'LineNumSap', sortable: false },
                { text: 'DESCRIPCIÓN PRODUCTO', value: 'OddDescription', sortable: false },
                { text: 'CANT. ENTRANTE', value: 'GrcQuantity', sortable: false, width: 110 },
                { text: 'RESTANTE', value: 'GrcRemaining', sortable: false, width: 110, align: 'center' },
                { text: 'CANT. TOTAL', value: 'OddQuantity', sortable: false, width: 110, align: 'center' },
                // { text: 'ESTADO', value: 'LineStatusSap', sortable: false, width: 110, align: 'center' },
            ],
            transferReasons: [],
            paymentTypes: [],
            grcItems: [],
            grcSelectedItems: [],
            grcForm: {
                GrcReasonPurchase: "*",
                U_SYP_MDTD: "00",
                GrcSerie: '',
                GrcCorrelative: '',
            },
            pdfFileGrc: null,
            xmlFileGrc: null,
            dialogDeliveryNoteDetails: false,
            selectedDeliveryNoteForDetails: null,
            xmlDataGrc: {
                invoiceNumber: '',
                total: 0, currency: '',
                documentTypeCode: '',
                issuerRUC: ''
            },
            processing: false,
            paginatedPages: [],
            htmlToPdfOptions: {
                margin: 0,
                filename: `Entrada_Mercancia.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: {
                    scale: 3,
                    useCORS: true,
                    letterRendering: true
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'portrait'
                }
            },
        }
    },
    computed: {
        fechaActual() {
            const hoy = new Date();
            return hoy.toLocaleDateString();
        },
        tipoDocumentoLabel() {
            if (!this.PurchaseDeliveryNote?.U_SYP_MDTD || this.PurchaseDeliveryNote?.U_SYP_MDTD === '00') {
                return '-';
            }
            console.log({ paymentTypes: this.paymentTypes })
            const found = this.paymentTypes.find(x => x.value === this.PurchaseDeliveryNote?.U_SYP_MDTD);
            return found ? found.text.toUpperCase() : '-';
        },
        cabecera() {
            const entNo = `${this.grcForm.GrcSerie || ''}-${this.grcForm.GrcCorrelative || ''}`.trim();
            return {
                entradaNo: entNo === '-' ? `OC-${this.orderLocal?.OrdDocumentNumber || 'TEMP'}` : entNo,
                proveedor: this.orderLocal?.SupName || '',
                ruc: this.orderLocal?.SupCode ? this.orderLocal.SupCode.replace(/^[A-Z]+/i, "") : "",
                direccion: this.orderLocal?.DirectionCompany || '',
                ggn: this.orderLocal?.Ggn || '',
                fecha: this.fechaActual,
                numJabas: this.orderLocal?.NumReq || '',
                fundo: this.orderLocal?.Fundo || '',
            };
        },
        itemsPDF() {
            const rate = parseFloat(this.PurchaseDeliveryNote?.DocRate) || 1;
            const isUSD = this.orderLocal?.TypeCurrency == 2;
            // const columnPriceCurrency = this.orderLocal.TypeCurrency == 2 ? 'Price' : 'LineTotal';
            // const columnVatCurrency = this.orderLocal.TypeCurrency == 2 ? 'LineVatS' : 'LineVat';
            return (this.PurchaseDeliveryNote && this.PurchaseDeliveryNote.DocumentLines ? this.PurchaseDeliveryNote.DocumentLines : []).map(item => {
                // const qty = parseFloat(item.Quantity) || 1;
                // const price = parseFloat(item.Price);
                // const PriceWithIGV = parseFloat(item.PriceAfterVAT);
                // const igv = (PriceWithIGV - price);
                // const precioME = isUSD ? item.Price : item.LineTotal / rate;
                // const precioMN = isUSD ? item.LineTotal * rate : item.LineTotal;
                const vatME = isUSD ? (item.PriceAfterVAT - item.Price) : item.LineVat / rate;
                const vatMN = isUSD ? (item.LineVat * rate) : item.LineVat;
                return {
                    codigo: item.ItemCode || '',
                    descripcion: item.ItemDescription || '',
                    cantidad: item.Quantity || 1,
                    um: item.MeasureUnit,
                    almacen: item.WarehouseCode || '',
                    precioME: item.Price,
                    precioMN: isUSD ? item.Price * item.Rate : 0,
                    vatME: vatME,
                    vatMN: vatMN,
                    totalME: isUSD ? item.Price * item.Quantity : 0,
                    totalMN: item.LineTotal
                };
            });
        },
        itemsPages() {
            const items = this.itemsPDF;
            const pages = [];
            if (items.length === 0) {
                pages.push({ items: [], startIndex: 0 });
                return pages;
            }
            let currentIndex = 0;
            while (currentIndex < items.length) {
                const isFirstPage = pages.length === 0;
                const remainingItems = items.length - currentIndex;
                let limit = 0;
                if (isFirstPage) {
                    if (remainingItems <= 13) {
                        limit = remainingItems;
                    } else {
                        limit = 13; // Toma 11 y deja el resto para la página 2
                    }
                } else {
                    if (remainingItems <= 15) {
                        limit = remainingItems;
                    } else {
                        limit = 15; // Toma 14 y deja el resto para la página siguiente
                    }
                }
                const chunk = items.slice(currentIndex, currentIndex + limit);
                pages.push({
                    items: chunk,
                    startIndex: currentIndex
                });
                currentIndex += limit;
            }
            return pages;
        },

        getHeadaersSummaryDeliveryNotes() {
            if (this.orderLocal.TypeOrder == 1) {
                return [
                    { text: 'N° DOC', value: 'DocNum', align: 'center', width: '90px', sortable: false },
                    // { text: 'L. BASE', value: 'BaseLine', align: 'center', width: '80px', sortable: false },
                    { text: 'PRODUCTO', value: 'Description', align: 'start', sortable: false },
                    // { text: 'PRECIO.', value: 'Price', align: 'center', width: '120px', sortable: false },
                    { text: 'CANT. ENTR.', value: 'Quantity', align: 'center', width: '110px', sortable: false },
                    { text: 'TOTAL', value: 'BaseQty', align: 'center', width: '100px', sortable: false },
                    { text: 'PRECIO', value: 'PriceAfVAT', align: 'center', width: '100px', sortable: false },
                    // { text: 'GUIA', value: 'U_SYP_MDSD', align: 'center', width: '100px', sortable: false },
                ];
            } else {
                return [
                    { text: 'N° DOC', value: 'DocNum', align: 'center', sortable: false },
                    { text: 'PRODUCTO', value: 'Description', align: 'start', sortable: false },
                    { text: 'PRECIO.', value: 'Price', align: 'center', width: '120px', sortable: false },
                    { text: 'CANT.', value: 'Quantity', align: 'center', width: '120px', sortable: false },
                    { text: 'TOTAL', value: 'PriceAfVAT', align: 'center', width: '120px', sortable: false },
                    // { text: 'FACTURA', value: 'U_SYP_MDSD', align: 'center', width: '110px', sortable: false },
                ];
            }
        },
        getLinesDeliveryNotes() {
            const list = (this.orderLocal.PurchaseDeliveryNotesDetail && this.orderLocal.PurchaseDeliveryNotesDetail.length > 0) ? this.orderLocal.PurchaseDeliveryNotesDetail : [];
            return list.map((item, index) => ({ ...item, uniqueId: 'dn-' + index }));
        },
        getAvailableArticlesToDelivery() {
            return (this.orderLocal.DocStatus == 'O' && this.grcItems.length > 0) ? this.grcItems.filter(x => x.LineStatusSap == 'O') : [];
        },
        groupedPurchaseDeliveryNotes() {
            const rawNotes = this.getLinesDeliveryNotes;
            const grouped = {};
            rawNotes.forEach(item => {
                const key = `${item.DocNum}_${item.DocDate}`;
                if (!grouped[key]) {
                    grouped[key] = {
                        DocNum: item.DocNum,
                        DocDate: item.DocDate,
                        U_SYP_MDSD: item.U_SYP_MDSD,
                        U_SYP_MDCD: item.U_SYP_MDCD,
                        Currency: item.Currency,
                        items: [],
                        uniqueId: key
                    };
                }
                grouped[key].items.push(item);
            });
            return Object.values(grouped).sort((a, b) => {
                const numA = parseInt(a.DocNum, 10);
                const numB = parseInt(b.DocNum, 10);
                if (!isNaN(numA) && !isNaN(numB)) {
                    return numB - numA;
                }
                return (b.DocNum || '').localeCompare(a.DocNum || '');
            });
        },
        getGroupedHeadersSummaryDeliveryNotes() {
            if (this.orderLocal.TypeOrder == 3) {
                return [
                    { text: 'N° DOC', value: 'DocNum', align: 'center', width: '110px', sortable: false },
                    { text: 'FECHA', value: 'DocDate', align: 'center', width: '90px', sortable: false },
                    { text: 'TOTAL', value: 'total', align: 'center', width: '100px', sortable: false },
                    { text: 'DOCUMENTOS', value: 'facturas', align: 'center', width: '100px', sortable: false },
                    { text: 'DETALLE', value: 'actions', align: 'center', width: '90px', sortable: false }
                ];
            } else {
                return [
                    { text: 'N° DOC', value: 'DocNum', align: 'center', width: '130px', sortable: false },
                    { text: 'FECHA', value: 'DocDate', align: 'center', width: '120px', sortable: false },
                    { text: 'DOCUMENTOS', value: 'facturas', align: 'center', width: '120px', sortable: false },
                    { text: 'DETALLE', value: 'actions', align: 'center', width: '90px', sortable: false }
                ];
            }
        },
        getDetailHeaders() {
            return this.getHeadaersSummaryDeliveryNotes.filter(h => h.value !== 'DocNum' && h.value !== 'DocDate');
        },
    },
    methods: {
        formatPrice(value, decimals) {
            if (value === null || value === undefined || value === '') return '0.' + '0'.repeat(decimals);
            const num = parseFloat(value);
            if (isNaN(num)) return '0.' + '0'.repeat(decimals);
            const parts = num.toFixed(decimals).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return parts.join('.');
        },
        formatHourSAP(horaSap) {
            if (!horaSap || horaSap == 0 || horaSap == -1) return "";
            const horaStr = horaSap.toString().padStart(6, "0");
            const horas = parseInt(horaStr.substring(0, 2), 10);
            const minutos = horaStr.substring(2, 4);
            const periodo = horas >= 12 ? "p.m." : "a.m.";
            const horas12 = horas % 12 || 12; // Si es 00 o 12, devuelve 12
            const horas12ConCero = horas12.toString().padStart(2, "0");
            return `${horas12ConCero}:${minutos} ${periodo}`;
        },
        openDeliveryNoteDetails(item) {
            this.selectedDeliveryNoteForDetails = item;
            this.dialogDeliveryNoteDetails = true;
        },
        downloadFileSummary(fileName) {
            if (fileName) {
                const newfileName = fileName.split(/[\\/]/).pop();
                _sGeneral.download(newfileName, this.$fun.getUserID()).then((r) => {
                    this.$fun.download(r.data, newfileName);
                });
            }
        },
        // Paso 2: Capturar el evento beforeDownload generado por la librería
        async onPdfGenerated({ html2pdf, options, pdfContent }) {
            console.log("--- INICIO onPdfGenerated (beforeDownload) ---");
            try {
                if (!html2pdf || !pdfContent) {
                    throw new Error("No se recibió la configuración o el contenido de html2pdf");
                }

                // 1. Generamos el PDF Blob usando html2pdf directamente y stampando pie de página
                console.log("Generando PDF Blob...");
                const blob = await html2pdf()
                    .set(options)
                    .from(pdfContent)
                    .toPdf()
                    .get('pdf')
                    .then((pdf) => {
                        const totalPages = pdf.internal.getNumberOfPages();
                        for (let i = 1; i <= totalPages; i++) {
                            pdf.setPage(i);
                            pdf.setFontSize(8);
                            pdf.setTextColor(100);
                            // Left side footer text
                            pdf.text('Documento generado por SunExpert', 12, 289);
                            // Right side footer text: Página X de Y (aligned right)
                            pdf.text('Página ' + i + ' de ' + totalPages, 198, 289, { align: 'right' });
                        }
                    })
                    .output('blob');
                console.log("Blob generado:", blob);

                // 2. Convertimos a base64 limpio (sin prefijo)
                console.log("Convirtiendo a Base64...");
                const base64Content = await this.convertBlobToBase64(blob);
                console.log("Base64 generado con éxito, longitud:", base64Content ? base64Content.length : 0);

                if (this.pdfResolve) {
                    this.pdfResolve(base64Content);
                    this.pdfResolve = null;
                    this.pdfReject = null;
                }
            } catch (error) {
                console.error("Error crítico durante la generación de la entrada de mercancía:", error);
                if (this.pdfReject) {
                    this.pdfReject(error);
                    this.pdfReject = null;
                    this.pdfResolve = null;
                }
            } finally {
                this.enviando = false;
                console.log("--- FIN onPdfGenerated ---");
            }
        },

        convertBlobToBase64(blob) {
            return new Promise((resolve, reject) => {
                try {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        const result = typeof reader.result === "string" ? reader.result : "";
                        const base64 = result.includes(",") ? result.split(",")[1] : result;
                        resolve(base64 || "");
                    };
                    reader.onerror = (err) => reject(err);
                    reader.readAsDataURL(blob);
                } catch (e) {
                    reject(e);
                }
            });
        },

        loadItemsPedidoSAP() {
            this.grcSelectedItems = [];
            if (!this.orderLocal || !this.orderLocal.OrdID) return [];
            if (this.orderLocal.TypeOrder != 1) return [];

            let itemsPedido = this.orderLocal.DetailPedidoSAP ? this.orderLocal.DetailPedidoSAP : [];
            this.grcItems = itemsPedido.map(item => ({
                ...item,
                // GrcQuantity: parseFloat(item.OpenQtySap) || 0,
                GrcQuantity: 0,
                GrcRemaining: parseFloat(item.OpenQtySap) - parseFloat(item.GrcQuantity) || 0,
            }));
            console.log(JSON.parse(JSON.stringify({ grcItemsPedidoSAP: this.grcItems })))
        },
        submitEntradaMercancia() {
            console.log(JSON.parse(JSON.stringify(this.grcSelectedItems, null, 2)));
            if (!this.grcSelectedItems || this.grcSelectedItems.length == 0) {
                this.$fun.alert('DEBE SELECCIONAR AL MENOS UN ÍTEM.', 'warning');
                return;
            }

            for (const item of this.grcSelectedItems) {
                if (!(parseFloat(item.GrcQuantity) > 0)) {
                    this.$fun.alert(`${item.OddDescription} NO TIENE UNA CANTIDAD ENTRANTE VALIDA.`, 'warning');
                    return
                }
                if (parseFloat(item.GrcQuantity) > parseFloat(item.OpenQtySap)) {
                    this.$fun.alert(`${item.OddDescription} TIENE UNA CANTIDAD ENTRANTE MAYOR A LA CANTIDAD RESTANTE DE LA OC.`, 'warning');
                    return
                }
            }

            // 2. Motivo requerido
            if (!this.grcForm.GrcReasonPurchase || this.grcForm.GrcReasonPurchase == "*") {
                this.$fun.alert('EL CAMPO MOTIVO DE TRASLADO ES REQUERIDO.', 'warning');
                return;
            }

            // 3. Tipo de Comprobante requerido
            if (!this.grcForm.U_SYP_MDTD || this.grcForm.U_SYP_MDTD == "00") {
                this.$fun.alert('EL CAMPO TIPO DE COMPROBANTE ES REQUERIDO.', 'warning');
                return
            }

            // 4 & 5. Validación de Serie y Correlativo
            const serie = (this.grcForm.GrcSerie || '').trim();
            const correlativo = (this.grcForm.GrcCorrelative || '').trim();
            if (!this.validateDocumentNumbers(serie, correlativo)) return;


            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0');
            let yyyy = today.getFullYear();
            today = yyyy + '-' + mm + '-' + dd;

            // Construir payload
            const payload = {
                CardCode: this.orderLocal?.SupCode ?? "", // "PN20601282071"
                DocDate: today,
                DocDueDate: today,
                U_SYP_MDMT: this.grcForm.GrcReasonPurchase, //02 : COMPRA NACIONAL
                U_SYP_MDTD: this.grcForm.U_SYP_MDTD, //09 : GRE
                U_SYP_MDSD: serie,
                U_SYP_MDCD: correlativo,
                DocumentLines: this.grcSelectedItems.map((item) => ({
                    BaseLine: parseInt(item?.LineNumSap ?? (item.Line - 1)), //0
                    BaseType: 22,
                    BaseEntry: parseInt(this.orderLocal.DocEntry), //78417
                    Quantity: item.GrcQuantity,
                })),
            };

            console.log('Payload:', JSON.parse(JSON.stringify(payload, null, 2)));

            if (payload.CardCode == "") {
                this.$fun.alert('NO SE ENCONTRO EL PROVEEDOR EN LA ORDEN', 'warning');
                return;
            }

            if (!parseInt(payload.DocumentLines[0].BaseEntry ?? 0) > 0) {
                this.$fun.alert('DocEntry NO ENCONTRADO EN LA ORDEN', 'warning');
                return;
            }

            // return;

            this.$fun.alert("Seguro de Generar Entrada de Mercancía SAP?", "question").then(async (r) => {
                if (r.value) {
                    this.processing = true;

                    let pathInvoiceNumberXml = null;
                    let pathInvoiceNumberPdf = null;

                    if (this.xmlFileGrc) {
                        const docType = this.grcForm.U_SYP_MDTD || '00';
                        const ruc = this.xmlDataGrc?.issuerRUC || payload.CardCode.replace(/^[A-Z]+/i, '') || 'RUC';
                        const fileNum = this.xmlDataGrc?.invoiceNumber || `${serie}-${correlativo}`;
                        const fileName = `${ruc}-${docType}-${fileNum}`;

                        const uploadedXML = await this.loadFileOnServer(this.xmlFileGrc, fileName);
                        if (uploadedXML && uploadedXML.success) {
                            pathInvoiceNumberXml = uploadedXML.path;
                        } else {
                            this.$fun.alert("Error al subir XML: " + (uploadedXML?.message || 'Error'), "error");
                            this.processing = false;
                            return;
                        }

                        if (this.pdfFileGrc) {
                            const uploadedPDF = await this.loadFileOnServer(this.pdfFileGrc, fileName);
                            if (uploadedPDF && uploadedPDF.success) {
                                pathInvoiceNumberPdf = uploadedPDF.path;
                            } else {
                                this.$fun.alert("Error al subir PDF: " + (uploadedPDF?.message || 'Error'), "error");
                                this.processing = false;
                                return;
                            }
                        }
                    }

                    if (pathInvoiceNumberPdf) {
                        payload.U_SYP_ANEXO3 = pathInvoiceNumberPdf;
                    }
                    if (pathInvoiceNumberXml) {
                        payload.U_SYP_ANEXO4 = pathInvoiceNumberXml;
                    }

                    const capturarRespuestaOk = async (deliveryOrder) => {
                        console.log(JSON.parse(JSON.stringify({ deliveryOrder })));
                        this.PurchaseDeliveryNote = deliveryOrder.data;
                        if (this.ValidateBudget == 1) {
                            await this.updateBudgetForAllProjects(this.grcSelectedItems);
                        }
                        await this.updateStatusOrderAfterDispatch();

                        // Generar el PDF del comprobante de entrada recién registrado
                        let base64Pdf = null;
                        try {
                            await this.$nextTick();
                            base64Pdf = await new Promise((resolve, reject) => {
                                this.pdfResolve = resolve;
                                this.pdfReject = reject;

                                const timeout = setTimeout(() => {
                                    if (this.pdfResolve) {
                                        reject(new Error("Timeout generating PDF"));
                                        this.pdfResolve = null;
                                        this.pdfReject = null;
                                    }
                                }, 15000);

                                const origResolve = resolve;
                                resolve = (val) => {
                                    clearTimeout(timeout);
                                    origResolve(val);
                                };

                                this.$refs.html2Pdf.generatePdf();
                            });
                        } catch (pdfErr) {
                            console.error("No se pudo generar el PDF del resumen de entrada:", pdfErr);
                        }

                        await this.sendEmailToProveedor(deliveryOrder.data, this.grcSelectedItems, base64Pdf);

                        this.grcSelectedItems = [];
                        this.grcForm = {
                            GrcReasonPurchase: "*",
                            U_SYP_MDTD: "00",
                            GrcSerie: '',
                            GrcCorrelative: '',
                        }
                        this.pdfFileGrc = null;
                        this.xmlFileGrc = null;
                        this.xmlDataGrc = {
                            invoiceNumber: '',
                            total: 0,
                            currency: '',
                            documentTypeCode: '',
                            issuerRUC: ''
                        }
                        this.$emit("SavedDeliveryNote");

                        this.$fun.alert("Entrada de Mercancía registrada correctamente", "success");
                        this.processing = false;
                        // this.$emit("onClose");
                    }

                    const capturarError = (error) => {
                        this.grcSelectedItems = [];
                        this.processing = false;
                        let errorMsg = error?.response?.data?.Message || "Error desconocido";

                        try {
                            const parsed = JSON.parse(errorMsg);
                            if (parsed.error) {
                                try {
                                    const sapError = JSON.parse(parsed.error);
                                    errorMsg = sapError?.error?.message?.value || parsed.userFriendlyMessage || errorMsg;
                                } catch (e) {
                                    errorMsg = parsed.userFriendlyMessage || errorMsg;
                                }
                                if (errorMsg.includes("Update the exchange rate")) {
                                    errorMsg = "Actualizar el tipo de cambio";
                                }
                            } else if (parsed.userFriendlyMessage) {
                                errorMsg = parsed.userFriendlyMessage;
                            }
                        } catch (e) {
                            // Si no es un JSON válido, conservamos el mensaje original
                        }

                        this.message = errorMsg;
                        this.$fun.alert(errorMsg, 'error');
                    }

                    _sOrderPurchase.loadPurchaseDeliveryNoteSapDemo(payload, this.$fun.getUserSAPInfo().UsrID, this.$fun.getUserID()).then(capturarRespuestaOk, capturarError);
                }
            });
        },
        validateDocumentNumbers(serie, correlativo) {
            serie = (serie || '').trim();
            if (!serie) {
                this.$fun.alert('EL CAMPO SERIE ES REQUERIDO.', 'warning');
                return false;
            } else if (serie.length !== 4) {
                this.$fun.alert('LA SERIE DEBE TENER EXACTAMENTE 4 CARACTERES.', 'warning');
                return false;
            } else if (!/^[A-Z0-9]{4}$/.test(serie)) {
                this.$fun.alert('LA SERIE SOLO ADMITE LETRAS MAYÚSCULAS (A-Z) Y NÚMEROS (0-9), SIN ESPACIOS NI CARACTERES ESPECIALES.', 'warning');
                return false;
            }

            correlativo = (correlativo || '').trim();
            if (!correlativo) {
                this.$fun.alert('EL CAMPO CORRELATIVO ES REQUERIDO.', 'warning');
                return false;
            } else if (!/^[0-9]{1,8}$/.test(correlativo)) {
                this.$fun.alert('EL CORRELATIVO SOLO ADMITE DÍGITOS NUMÉRICOS (0-9) Y UN MÁXIMO DE 8 DÍGITOS.', 'warning');
                return false;
            }
            return true;
        },
        async loadFileOnServer(model, fileName, paramRoute = "RutaAnexosSAP", overwrite = true) {
            try {
                const response = await _GenUploadFiles.upload(model, fileName.toUpperCase(), paramRoute, overwrite);
                console.log({ response })
                if (response.status == 200) {
                    return {
                        success: true,
                        message: response.data.message,
                        path: response.data.path,
                        fileName: response.data.fileName,
                    }
                } else {
                    return {
                        success: false,
                        message: 'Error al subir archivo',
                    }
                }
            } catch (error) {
                console.log("Error on loadFileOnServer: ", error);
                let errMsg = error.message;
                if (error?.response?.data?.Message) {
                    errMsg = error.response.data.Message;
                }
                return {
                    success: false,
                    message: errMsg || 'Error al subir archivo',
                }
            }
        },
        handleFileEvent(e) {
            const file = e.target.files[0];
            if (!file) {
                this.xmlDataGrc = {
                    invoiceNumber: '',
                    total: 0,
                    currency: '',
                    documentTypeCode: '',
                    issuerRUC: ''
                };
                return;
            }

            this.xmlFileGrc = file;
            this.pdfFileGrc = null;
            if (this.$refs.fileInputPDF_grc) this.$refs.fileInputPDF_grc.value = "";

            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(e.target.result, "text/xml");
                    const root = xmlDoc.documentElement;

                    // Helper: texto limpio de un nodo
                    const txt = (node) => (node?.textContent || '').trim();

                    // Helper: busca por localName probando 3 formas para cubrir cualquier namespace
                    const byLocal = (localName) => {
                        return root.getElementsByTagNameNS("*", localName)[0]
                            || root.getElementsByTagName("cbc:" + localName)[0]
                            || root.getElementsByTagName(localName)[0]
                            || null;
                    };

                    // ── 1. Tipo de documento ───────────────────────────────────────────
                    let documentTypeCode = '';

                    const despatchTypeNode = byLocal('DespatchAdviceTypeCode'); // GRE=09 | GRT=31
                    const invoiceTypeNode = byLocal('InvoiceTypeCode');        // Factura/Boleta
                    const creditNoteNode = byLocal('DiscrepancyResponse');    // Nota Crédito
                    const debitNoteNode = byLocal('DebitReasonCode');        // Nota Débito

                    if (despatchTypeNode) {
                        // Usamos el valor real del tag (puede ser "09" para GRE o "31" para GRT)
                        // Solo caemos a "09" si el tag existe pero su contenido es vacío
                        const val = txt(despatchTypeNode);
                        documentTypeCode = val !== '' ? val : '09';
                    } else if (invoiceTypeNode) {
                        const val = txt(invoiceTypeNode);
                        documentTypeCode = val !== '' ? val : '01';
                    } else if (creditNoteNode) {
                        documentTypeCode = '07';
                    } else if (debitNoteNode) {
                        documentTypeCode = '08';
                    } else {
                        // Fallback por nombre del elemento raíz
                        const rootName = root.localName || root.nodeName.split(':').pop();
                        if (rootName.includes('DespatchAdvice')) documentTypeCode = '09';
                        else if (rootName.includes('CreditNote')) documentTypeCode = '07';
                        else if (rootName.includes('DebitNote')) documentTypeCode = '08';
                        else documentTypeCode = '01';
                    }
                    // ── 2. Número del comprobante ─────────────────────────────
                    // Primer hijo elemento del root con localName "ID"
                    let invoiceNumber = '';
                    const rootChildren = root.childNodes;
                    for (let i = 0; i < rootChildren.length; i++) {
                        const child = rootChildren[i];
                        const lname = child.localName || child.nodeName.split(':').pop();
                        if (child.nodeType === 1 && lname === 'ID') {
                            invoiceNumber = (child.textContent || '').trim();
                            break;
                        }
                    }

                    // ── 3. Guardar y autocompletar ─────────────────────────────
                    const xmlData = {
                        invoiceNumber,
                        documentTypeCode,
                        issuerRUC: '',
                        total: 0,
                        currency: 'PEN'
                    };

                    // Serie y Correlativo
                    let GrcSerie = '';
                    let GrcCorrelative = '';
                    if (invoiceNumber.includes('-')) {
                        const parts = invoiceNumber.split('-');
                        GrcSerie = parts[0].trim().substring(0, 4).toUpperCase();
                        GrcCorrelative = parts[1].trim().substring(0, 8);
                    } else {
                        GrcSerie = '';
                        GrcCorrelative = invoiceNumber.trim().substring(0, 8);
                    }

                    this.xmlDataGrc = xmlData;
                    this.grcForm.GrcSerie = GrcSerie;
                    this.grcForm.GrcCorrelative = GrcCorrelative;
                    if (documentTypeCode) {
                        this.grcForm.U_SYP_MDTD = documentTypeCode;
                    }

                    console.log('[XML parsed]', { documentTypeCode, invoiceNumber });
                } catch (error) {
                    console.log("Error al parsear XML:", error);
                    this.$fun.alert("Error al leer el archivo XML.", "error");
                }
            };
            reader.readAsText(file);
        },
        clearXMLFile() {
            this.xmlFileGrc = null;
            this.pdfFileGrc = null;
            this.xmlDataGrc = {
                invoiceNumber: '',
                total: 0,
                currency: '',
                documentTypeCode: '',
                issuerRUC: ''
            };
            if (this.$refs.fileInputXML_grc) this.$refs.fileInputXML_grc.value = "";
            if (this.$refs.fileInputPDF_grc) this.$refs.fileInputPDF_grc.value = "";

        },
        handlePDFFileEvent(e) {
            const file = e.target.files[0];
            if (file) {
                this.pdfFileGrc = file;
            }
        },
        clearPDFFile() {
            this.pdfFileGrc = null;
            if (this.$refs.fileInputPDF_grc) this.$refs.fileInputPDF_grc.value = "";
        },
        onGrcItemSelected({ item, value }) {
            if (value && item.LineStatusSap == 'O' && item.GrcQuantity == 0) {
                item.GrcQuantity = parseFloat(item.OpenQtySap) || 0;
            }
        },
        onGrcSelectAll({ items, value }) {
            if (value) {
                items.filter(i => i.LineStatusSap == 'O').forEach(item => {
                    if (item.GrcQuantity == 0) {
                        item.GrcQuantity = parseFloat(item.OpenQtySap) || 0;
                    }
                });
            }
        },
        grcIsSelected(item) {
            return this.grcSelectedItems.some(s => s.Line === item.Line);
        },
        async loadSelected(selectedField, targetProperty) {
            try {
                const response = await _sSaleOrder.list_selected({ selected: selectedField }, this.$fun.getUserID());
                if (response.status === 200 && response.data) {
                    this[targetProperty] = response.data;
                }
            } catch (error) {
                console.log(`Error al cargar ${selectedField}:`, error);
            }
        },
        onGrcQtyInput(item) {
            if (item.GrcQuantity < 0) item.GrcQuantity = 0;
        },
        onGrcQtyBlur(item) {
            if (!item.GrcQuantity || item.GrcQuantity < 0) item.GrcQuantity = 0;
            if (item.GrcQuantity > parseFloat(item.OddQuantity || 0)) {
                this.$fun.alert(`La cantidad entrante supera la cantidad de la OC (${item.OddQuantity}). El restante será negativo.`, 'warning');
            }
        },

        async getBudget(item) {
            const usrID = this.$fun.getUserID();
            const year = this.orderLocal.OrdDate ? this.orderLocal.OrdDate.split('-')[0] : new Date().getFullYear();
            const userInfo = this.$fun.getUserInfo();
            const AreID = (userInfo && userInfo.CtrContract) ? (userInfo.CtrContract.AreID ?? 0) : 0;

            if (!AreID) {
                console.log('NO SE ENCONTRÓ AREA DEL USUARIO');
                return null;
            }

            const params = {
                PrjCode: item.PrjCode,
                AreID: AreID,
                BslID: item.BslID,
                BgtYear: year,
            };

            const resultadoBudget = await TrsBudgeService.list(params, usrID);
            console.log(JSON.parse(JSON.stringify({ params, resultadoBudget })));

            if (resultadoBudget.status == 200 && resultadoBudget.data.length > 0) {
                return resultadoBudget.data[0];
            }
            return null;
        },

        async updateBudgetForAllProjects(items = []) {

            // const tipoCambio = await this.getExchangeRate(new Date(), 'US$');
            const seen = new Set();
            const uniqueItems = items.filter(i => {
                if (!i.PrjCode || i.PrjCode == '00000') return false;
                const key = `${i.PrjCode}|${i.BslID}`;
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
            console.log(JSON.parse(JSON.stringify({ uniqueItems })));
            await Promise.all(uniqueItems.map(i => this.updateBudgetDatabase(i, items)));
        },

        async updateBudgetDatabase(item, items = []) {
            const budget = await this.getBudget(item);
            if (!budget) {
                console.log('updateBudget: no se encontró presupuesto para PRJ CODE: ' + item.PrjCode + ' - BSL : ' + item.BslID);
                return;
            }

            try {
                console.log(JSON.parse(JSON.stringify({ budget })));
                const groupItems = items.filter(i => i.PrjCode == item.PrjCode && i.BslID == item.BslID);
                const usrID = this.$fun.getUserID();
                const ordDate = this.orderLocal.OrdDate || new Date();

                const saves = groupItems.map(groupItem => {

                    const BdgAmount = groupItem.TypeCurrency == 2 ? (groupItem.OddAmount * (budget.BgtRatePrice || 1)) : groupItem.OddAmount;
                    const BgdAmountUSD = groupItem.TypeCurrency == 2 ? groupItem.OddAmount : (groupItem.OddAmount / (budget.BgtRatePrice || 1)).toFixed(3);

                    const modelDetail = {
                        BgdID: 0,
                        BgtID: budget.BgtID,
                        BgdDescription: groupItem.OddDescription || '',
                        BgdAmount: parseFloat(BdgAmount) || 0,
                        BgdRatePrice: budget.BgtRatePrice,
                        BgdCurrencyType: groupItem.TypeCurrency,
                        BgdAmountUSD,
                        BgdOperationType: 1,           // Restar
                        BgdDate: ordDate,
                        BdgReqID: groupItem.ReqID || null,  // ID Requerimiento origen (si aplica)
                        BdgReference: groupItem.ReqID ? 2 : 3, // //Si hay ReqId ? REQUERIMIENTO : ORDEN COMPRA
                        BdgReferenceID: groupItem.OddID || null, // ID linea de orden (OddID)
                        BdgState: 2,                  // 1 = Ejecutado
                        SecStatus: 1,
                        UsrCreateID: usrID,
                    };

                    console.log(JSON.parse(JSON.stringify({ modelDetail })));
                    return TrsBudgetDetailService.save(modelDetail, usrID)
                        .then(r => console.log(`[BudgetDetail] BgtID=${budget.BgtID} item saved`, r.status))
                        .catch(err => console.log('[BudgetDetail] Error guardando detalle:', err));
                });

                await Promise.all(saves);
            } catch (error) {
                console.log('Error al actualizar detalle del presupuesto:', error);
            }
        },

        async getExchangeRate(date, currencyType) {
            try {
                const result = await _sOtherSupportService.exchangeratesap(date, currencyType, this.$fun.getUserID());
                if (result.status == 200 && result.data && result.data.Rate) {
                    console.log(JSON.parse(JSON.stringify({ result: result.data })));
                    return result.data.Rate;
                }
                return null;
            } catch (error) {
                console.log("Error al obtener la tasa de cambio:", error);
                return null;
            }
        },

        async updateStatusOrderAfterDispatch() {
            if ([5, 10].includes(this.orderLocal.OrdStatus)) {
                try {
                    const updatedSAP = await _sOrderPurchase.setStatusAfterDispatch(this.orderLocal, this.$fun.getUserID());
                    console.log(JSON.parse(JSON.stringify({ updatedSAP })));
                } catch (error) {
                    console.log("Error on updateStatusOrderAfterDispatch:", error);
                }
            }
        },

        async sendEmailToProveedor(deliveryOrder, items = [], base64Pdf = null) {

            const emailCCList = [];
            const emailBody =
                `<!DOCTYPE html>
                    <html>
                    <head>
                        <meta charset="utf-8">
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    </head>
                    <body style="margin: 0; padding: 0; background-color: #f4f5f7; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; color: #333333; -webkit-font-smoothing: antialiased;">
                        <div style="max-width: 600px; margin: 40px auto; background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 4px 6px rgba(0,0,0,0.05); border: 1px solid #e1e4e8;">
                            <div style="background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%); padding: 60px 20px; text-align: center; color: #ffffff;">
                                <h1 style="margin: 0; font-size: 28px; font-weight: 700; letter-spacing: -0.5px; color: #ffffff;">Registro de Entrada de Mercancía</h1>
                            </div>

                            <div style="padding: 40px; text-align: center; font-size: 16px; line-height: 1.6; color: #475569;">
                                <p style="margin: 0 0 20px 0;">Estimado Proveedor <strong>${deliveryOrder?.CardName}</strong>,</p>

                                <p style="margin: 0 0 20px 0;">Le informamos que hemos registrado en nuestro sistema la <strong>entrada de mercancía</strong> correspondiente a su última entrega. El proceso ha sido verificado satisfactoriamente por nuestro equipo de almacén.</p>

                                <p style="margin: 0 0 28px 0; font-weight: 600; color: #1e3a8a;">Por favor, acceda al portal de proveedores para cargar la factura correspondiente a esta recepción, junto con la documentación de soporte requerida.</p>

                                <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 20px; margin: 0 0 32px; text-align: left; font-size: 14px; color: #475569;">
                                    <p style="margin: 0 0 12px; font-weight: 600; color: #1e3a8a; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px;">Datos del registro</p>
                                    <table style="width: 100%; border-collapse: collapse;">
                                        <tr>
                                            <td style="padding: 5px 0; color: #64748b;">N.° de entrada:</td>
                                            <td style="padding: 5px 0; font-weight: 600; text-align: right;">${deliveryOrder?.DocNum}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 5px 0; color: #64748b;">Fecha de recepción:</td>
                                            <td style="padding: 5px 0; font-weight: 600; text-align: right;">${this.$fun.formatDateView(deliveryOrder?.DocDate)}</td>
                                        </tr>
                                    </table>
                                </div>

                                <div style="margin: 35px 0;">
                                    <a href="${this.UrlSunSupply}" style="display: inline-block; background-color: #2563eb; color: #ffffff; text-decoration: none; padding: 14px 32px; border-radius: 30px; font-weight: 600; font-size: 16px; text-align: center;">Cargar Factura en el Portal</a>
                                </div>
                            </div>

                            <div style="padding: 0 40px 40px 40px; font-size: 13px; color: #64748b; text-align: center;">
                                <div style="border-top: 1px solid #e2e8f0; padding-top: 30px;">
                                    <p style="margin: 0 0 8px;">Si tiene alguna consulta sobre este registro o la documentación requerida, comuníquese con el área de compras o logística.</p>
                                    <p style="margin: 0; font-size: 12px; color: #94a3b8;">Este correo fue generado automáticamente, por favor no responda directamente a este mensaje.</p>
                                </div>
                            </div>
                        </div>
                    </body>
                </html>`;

            const mailPayload = {
                emailTo: 'desarrollador.ti@sunshineperu.com', // supplierEmail,
                emailCC: emailCCList,
                subject: `SUNSHINE - Registro de Entrada de Mercancía ${deliveryOrder?.DocNum}`,
                bodyMail: emailBody,
                attachments: []
            };

            if (base64Pdf) {
                mailPayload.attachments.push({
                    attachmentBytes: base64Pdf,
                    nameFile: `${deliveryOrder?.DocNum}.pdf`
                });
                await _sGenEmail.sendEmailWithAttach(mailPayload, this.$fun.getUserID());
            } else {
                await _sGenEmail.sendEmail(mailPayload, this.$fun.getUserID());
            }
            console.log(`Notificación de entrada de mercancía enviada a ${deliveryOrder?.CardName}`);
        }
    },
    watch: {
        "orderLocal": {
            immediate: true,
            deep: true,
            handler(val) {
                console.log(val);
                if (val != null) {
                    this.loadItemsPedidoSAP();
                }
            }
        }
    },

    async created() {
        await this.loadSelected('U_SYP_MDMT', 'transferReasons');
        await this.loadSelected('U_SYP_MDTD', 'paymentTypes');
        console.log(JSON.parse(JSON.stringify({ ...this.$fun.getUserInfo(), UsrID: this.$fun.getUserID() })))
        _sGenParam.search({ PrmName: "ValidateBudget" }, this.$fun.getUserID()).then(resp => {
            this.ValidateBudget = resp.data.PrmValue;
        });
        _sGenParam.search({ PrmName: "UrlSunSupply" }, this.$fun.getUserID()).then(resp => {
            this.UrlSunSupply = resp.data.PrmValue;
        });
    },

}

</script>

<style scoped>
/* --- ESTILOS PARA EL PDF DE ENTRADA DE MERCANCÍA (SAP-style) --- */
.pdf-container {
    position: absolute;
    left: -9999px;
    top: -9999px;
    opacity: 0;
    pointer-events: none;
}

.sap-report {
    padding: 0;
    font-family: 'Arial', sans-serif;
    color: #000;
    background-color: #fff;
    width: 210mm;
    box-sizing: border-box;
}

.pdf-page-container {
    width: 210mm;
    height: 296mm;
    padding: 8mm 12mm;
    box-sizing: border-box;
    position: relative;
    background-color: #fff;
    overflow: hidden;
}

.pdf-page-container:not(:last-child) {
    page-break-after: always !important;
    break-after: always !important;
}

.sap-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border-bottom: 2px solid #000;
    padding-bottom: 8px;
    margin-bottom: 8px;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
}

.company-info {
    flex: 1;
}

.brand-title {
    font-size: 28px;
    font-weight: bold;
    color: #1b365d;
    margin: 0;
    text-align: center;
    text-transform: uppercase;
}

.company-name {
    font-size: 12px;
    font-weight: bold;
    margin: 4px 0 2px;
    text-align: center;
}

.company-tel {
    text-align: center;
    font-size: 10px;
    color: #555;
    margin: 0;
}

.document-title {
    text-align: right;
}

.document-title h2 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    color: #000;
    letter-spacing: 0.5px;
}

.sap-metadata {
    margin-bottom: 20px;
    font-size: 10px;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
}

.left-meta {
    width: 60%;
}

.left-meta p {
    margin: 4px 0;
    line-height: 1.4;
}

.right-meta {
    width: 35%;
}

.meta-table {
    width: 100%;
    border-collapse: collapse;
}

.meta-table td {
    padding: 3px 0;
    border: none;
}

.meta-label {
    text-align: right;
    padding-right: 10px !important;
    font-weight: bold;
}

.meta-value {
    text-align: left;
}

.font-bold {
    font-weight: bold;
}

.sap-items-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    font-size: 9px;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
}

.sap-items-table tr {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
}

.sap-items-table th,
table.sap-items-table thead tr th {
    border: 1px solid #000 !important;
    padding: 10px 8px !important;
    text-align: center !important;
    font-weight: bold !important;
}

.sap-items-table td,
table.sap-items-table tbody tr td {
    border: 1px solid #000 !important;
    padding: 10px 8px !important;
    vertical-align: middle !important;
}

.sap-items-table td.desc-cell,
table.sap-items-table tbody tr td.desc-cell {
    white-space: normal !important;
    word-break: break-word;
    text-align: left !important;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.sap-totals-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
}

.sap-totals-table {
    width: 40%;
    border-collapse: collapse;
    font-size: 11px;
}

.sap-totals-table td,
table.sap-totals-table tbody tr td {
    padding: 6px 10px !important;
    border: none !important;
}

.totals-label {
    text-align: right;
    font-weight: bold;
    padding-right: 15px !important;
}

.border-double-top td {
    border-top: 3px double #000;
}

.sap-footer {
    border-top: 1px solid #000;
    padding-top: 8px;
    font-size: 9px;
    color: #555;
    text-align: center;
}



.ios-tab-pane {
    animation: ios-pane-enter 0.28s ease;
}

@keyframes ios-pane-enter {
    from {
        opacity: 0;
        transform: translateY(6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ══════════════════════════════════════════════════════════
   GRC — Entradas de Mercancía Panel  (dark gray + purple)
══════════════════════════════════════════════════════════ */

/* ── Header ───────────────────────────────────────────── */
.grc-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    padding: 6px 8px;
    background: linear-gradient(135deg, #04abc5 0%, #04abc5 100%);
    /* background: linear-gradient(90deg, rgba(108, 99, 255, 0.06) 0%, rgba(167, 139, 250, 0.04) 100%); */
    border-radius: 12px;
    border: 1px solid rgba(167, 139, 250, 0.18);
}

.grc-header-icon {
    background: rgba(255, 255, 255, 0.3);
    padding: 6px;
    border-radius: 10px;
    backdrop-filter: blur(10px);
}

.grc-header-left {
    display: flex;
    align-items: center;
    gap: 6px;
}

.grc-header-title {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #FFF;
    letter-spacing: 0.3px;
}

.grc-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.grc-selected-label {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 12px;
    color: #FFF;
}

.grc-col-table {
    /* flex: 1 1 0; */
    min-width: 0;
}

.grc-col-form {
    /* flex: 0 0 260px; */
    /* width: 260px; */
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid rgba(167, 139, 250, 0.15);
    padding: 16px 14px 18px;
    display: flex;
    flex-direction: column;
    gap: 0;
}

/* ── Table ────────────────────────────────────────────── */
.grc-table {
    border-radius: 12px !important;
    overflow: hidden;
    background: #ffffff !important;
    box-shadow: 0 2px 12px rgba(108, 99, 255, 0.08) !important;
}

.grc-table>>>thead th {
    background: #f5f3ff !important;
    color: #374151 !important;
    font-weight: 700 !important;
    font-size: 10px !important;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    border-bottom: 1px solid rgba(108, 99, 255, 0.12) !important;
}

.grc-table>>>tbody tr {
    background: #ffffff;
}

/* checkbox color override */
.grc-table>>>.v-data-table__checkbox .v-icon {
    color: #04abc5 !important;
}

.grc-desc-text {
    font-size: 12px;
    color: #374151;
    line-height: 1.4;
}

.grc-mono {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: #374151;
}

.grc-qty-chip {
    font-weight: 700 !important;
    min-width: 36px;
    justify-content: center;
}

.grc-qty-input>>>input {
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    color: #1F2937;
}

.grc-qty-input>>>.v-input__slot {
    background: #faf5ff !important;
    border-color: rgba(108, 99, 255, 0.25) !important;
}

.grc-qty-input.error--text>>>.v-input__slot {
    border-color: #EF4444 !important;
    background: #FEF2F2 !important;
}

.grc-total-text {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 700;
    color: #374151;
}

/* ── Right-panel form ─────────────────────────────────── */
.grc-form-title {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 11px;
    font-weight: 700;
    color: #04abc5 !important;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.grc-field-wrap {
    margin-bottom: 10px;
}

.grc-row-inline {
    display: flex;
    gap: 8px;
}

.grc-field-half {
    flex: 1 1 0;
    min-width: 0;
}

.grc-input-label {
    display: block;
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 11px;
    font-weight: 600;
    color: #6B7280;
    letter-spacing: 0.3px;
    margin-bottom: 2px;
    padding-left: 2px;
}

/* Dark inputs inside the form panel */
.grc-col-form>>>.v-input__slot {
    background: #faf5ff !important;
    border-color: rgba(108, 99, 255, 0.22) !important;
    border-radius: 8px !important;
}

.grc-col-form>>>.v-label {
    color: #6B7280 !important;
    font-size: 12px;
}

.grc-col-form>>>input,
.grc-col-form>>>.v-select__selection {
    color: #1F2937 !important;
    font-size: 13px;
}

.grc-col-form>>>.v-input__control>>>.v-input__slot:hover {
    border-color: #a78bfa !important;
}

/* Total banner */
.grc-total-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;
    padding: 10px 12px;
    background: linear-gradient(135deg, rgba(108, 99, 255, 0.08), rgba(167, 139, 250, 0.12));
    border-radius: 10px;
    border: 1px solid rgba(167, 139, 250, 0.20);
}

.grc-total-banner-label {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 11px;
    color: #4B5563;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.grc-total-banner-value {
    font-family: 'Roboto Mono', monospace;
    font-size: 15px;
    font-weight: 700;
    color: #1F2937;
}

/* Save button */
.grc-save-btn {
    font-weight: 700 !important;
    letter-spacing: 1px !important;
    text-transform: none !important;
    background: linear-gradient(135deg, #2ccbe3, #04abc5) !important;
    box-shadow: 0 4px 14px rgba(124, 58, 237, 0.40) !important;
    transition: transform 0.15s ease, box-shadow 0.15s ease !important;
}

.grc-save-btn:not(.v-btn--disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(124, 58, 237, 0.55) !important;
}

.product-cell {
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 4px 0;
}

.product-code {
    font-family: 'Consolas', monospace;
    font-size: 12px;
    font-weight: 700;
    color: #0f172a;
    align-self: flex-start;
}

.product-desc {
    font-size: 11px;
    color: #64748b;
}

/* Componentes Visuales Breves (Badges) */
.whs-badge {
    background: #f1f5f9;
    color: #334155;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
}

.qty-value {
    font-size: 13px;
    font-weight: 700;
    color: #0f172a;
}

.qty-unit {
    font-size: 10px;
    color: #94a3b8;
    text-transform: uppercase;
}

.currency-value {
    font-size: 12px;
    color: #334155;
}

/* Resalte de la columna de Dinero Real Tangible */
.total-highlight {
    font-size: 13px;
    font-weight: 700;
    color: #0284c7;
    /* Azul corporativo */
}

/* Badges de Estado estilo Minimalista */
.status-c {
    background-color: #e2fbe8;
    color: #1e7e34;
}

.status-o {
    background-color: #fff3cd;
    color: #856404;
}

/* ── Responsive ────────────────────────────────────────── */
@media (max-width: 768px) {
    /* .grc-body {
        flex-direction: column;
    } */
}

.grc-chip-currency {
    background: linear-gradient(135deg, #6C63FF 0%, #a78bfa 100%) !important;
    color: #fff !important;
    font-weight: 700;
    font-size: 10px !important;
    letter-spacing: 0.5px;
}

.grc-total-pill {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #6C63FF, #a78bfa);
    padding: 3px 14px;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(108, 99, 255, 0.28);
    letter-spacing: 0.2px;
}

/* ── Items Table ──────────────────────────── */
.grc-table {
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(108, 99, 255, 0.07) !important;
}

.grc-table>>>thead th {
    background: linear-gradient(90deg, #f0eeff, #f5f3ff) !important;
    color: #5B4FC9 !important;
    font-weight: 700 !important;
    font-size: 11px !important;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.grc-table>>>tbody tr:hover {
    background: rgba(108, 99, 255, 0.04) !important;
}

.grc-table>>>tbody tr.v-data-table__selected {
    background: rgba(108, 99, 255, 0.09) !important;
}

.grc-desc-text {
    font-size: 12px;
    color: #374151;
    line-height: 1.4;
}

.grc-mono {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: #1F2937;
}

.grc-qty-chip {
    font-weight: 700 !important;
    min-width: 38px;
    justify-content: center;
}

.grc-qty-input>>>input {
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    color: #374151;
}

.grc-qty-input.error--text>>>.v-input__slot {
    border-color: #EF4444 !important;
    background: #FEF2F2 !important;
}

.grc-total-text {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 700;
    color: #4338CA;
}

/* ── Form Section ──────────────────────────── */
.grc-form-section {
    margin-top: 20px;
    padding: 16px;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 14px;
    border: 1px solid rgba(108, 99, 255, 0.10);
    box-shadow: 0 1px 6px rgba(108, 99, 255, 0.06);
}

.grc-form-title {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #6C63FF;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    display: flex;
    align-items: center;
}

.grc-field>>>.v-input__slot {
    border-radius: 8px !important;
}

/* ── Responsive ────────────────────────────── */
@media (max-width: 600px) {
    .grc-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .grc-total-pill {
        align-self: flex-end;
    }

    .grc-form-section {
        padding: 12px 10px;
    }
}

/* ── Document Upload Stack ─────────────────────────────── */
.doc-upload-stack {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.doc-upload-card {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 11px 14px 11px 8px;
    border-radius: 12px;
    border: 1.5px dashed #d1d9e6;
    background: #f9fbff;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    text-decoration: none;
}

.doc-upload-card:hover {
    border-style: solid;
    background: #f0f5ff;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(30, 64, 175, 0.07);
}

/* Loaded state — when a file is selected */
.doc-upload-card.loaded {
    border-style: solid;
    background: #ffffff;
}

/* Left accent stripe */
.doc-card-stripe {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-radius: 12px 0 0 12px;
}

.xml-stripe {
    background: linear-gradient(180deg, #16a34a 0%, #4ade80 100%);
}

.pdf-stripe {
    background: linear-gradient(180deg, #dc2626 0%, #f87171 100%);
}

/* Color themes per card type */
.xml-card {
    border-color: #bbf7d0;
}

.xml-card:hover {
    border-color: #22c55e;
}

.xml-card.loaded {
    border-color: #86efac;
    box-shadow: 0 4px 14px rgba(34, 197, 94, 0.10);
}

.xml-card .doc-card-icon {
    color: #16a34a;
}

.pdf-card {
    border-color: #fecaca;
}

.pdf-card:hover {
    border-color: #ef4444;
}

.pdf-card.loaded {
    border-color: #fca5a5;
    box-shadow: 0 4px 14px rgba(239, 68, 68, 0.10);
}

.pdf-card .doc-card-icon {
    color: #dc2626;
}

/* Icon column */
.doc-card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(248, 250, 255, 0.9);
    margin-left: 8px;
    margin-right: 12px;
    flex-shrink: 0;
    transition: background 0.2s ease;
}

.xml-card .doc-card-icon {
    background: rgba(34, 197, 94, 0.08);
}

.pdf-card .doc-card-icon {
    background: rgba(239, 68, 68, 0.08);
}

/* Text body */
.doc-card-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 0;
}

.doc-card-label {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #94a3b8;
    margin-bottom: 2px;
}

.doc-card-name {
    font-size: 0.78rem;
    font-weight: 600;
    color: #334155;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

/* Right side — badge / status */
.doc-card-right {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    margin-left: 8px;
}

.doc-card-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.6rem;
    font-weight: 800;
    letter-spacing: 0.8px;
    padding: 2px 8px;
    border-radius: 20px;
}

.xml-badge {
    background: rgba(34, 197, 94, 0.12);
    color: #16a34a;
    border: 1px solid #bbf7d0;
}

.pdf-badge {
    background: rgba(239, 68, 68, 0.10);
    color: #dc2626;
    border: 1px solid #fecaca;
}

.service-stripe {
    background: linear-gradient(180deg, #3b82f6 0%, #60a5fa 100%);
}

.service-card {
    border-color: #bfdbfe;
}

.service-card:hover {
    border-color: #3b82f6;
}

.service-card.loaded {
    border-color: #93c5fd;
    box-shadow: 0 4px 14px rgba(59, 130, 246, 0.10);
}

.service-card .doc-card-icon {
    color: #2563eb;
    background: rgba(37, 99, 235, 0.08);
}

.service-badge {
    background: rgba(59, 130, 246, 0.12);
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

.doc-card-success {
    display: flex;
    align-items: center;
    gap: 2px;
}

.doc-delete-btn {
    background: rgba(241, 245, 249, 0.9) !important;
    color: #94a3b8 !important;
    transition: all 0.15s ease;
}

.doc-delete-btn:hover {
    background: rgba(239, 68, 68, 0.12) !important;
    color: #dc2626 !important;
}

/* Slide-down transition for PDF card */
.slide-down-enter-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-down-leave-active {
    transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
}

.slide-down-enter,
.slide-down-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

.truncate-text {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── SAP Canceled Banner ── */
.sap-canceled-banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 28px 20px;
    height: 100%;
    min-height: 280px;
    border-radius: 1.5rem;
    background: linear-gradient(145deg, #fff5f5 0%, #fef2f2 60%, #fff0f0 100%);
    border: 1.5px solid rgba(239, 68, 68, 0.22);
    box-shadow: 0 4px 20px rgba(239, 68, 68, 0.09), inset 0 1px 0 rgba(255, 255, 255, 0.8);
    position: relative;
    overflow: hidden;
}

.sap-canceled-banner::before {
    content: '';
    position: absolute;
    top: -30px;
    right: -30px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(239, 68, 68, 0.18) 0%, transparent 70%);
    pointer-events: none;
}

.sap-canceled-icon-wrap {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(239, 68, 68, 0.15);
    border: 2px solid rgba(239, 68, 68, 0.4);
    margin-bottom: 16px;
    animation: sap-pulse 2.5s ease-in-out infinite;
}

@keyframes sap-pulse {

    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.3);
    }

    50% {
        box-shadow: 0 0 0 10px rgba(239, 68, 68, 0);
    }
}

.sap-canceled-title {
    font-size: 1rem;
    font-weight: 700;
    color: #dc2626;
    letter-spacing: 0.03em;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.sap-canceled-subtitle {
    font-size: 0.8rem;
    color: #6b7280;
    line-height: 1.55;
    margin-bottom: 16px;
}

.sap-canceled-subtitle strong {
    color: #b91c1c;
}
</style>
